import React from 'react'

import { shape, string } from 'prop-types'

import FormSubmit from 'Pods/DiscoverLandings/Shared/FormSubmit/FormSubmit'
import useLeadForm from 'Pods/DiscoverLandings/Shared/Hooks/useLeadForm'
import InputField from 'Pods/DiscoverLandings/Shared/InputField/InputField'
import SelectField from 'Pods/DiscoverLandings/Shared/SelectField/SelectField'

const CAPTCHA_ID = 'business-account-captcha'

const COMPANY_SIZE_OPTIONS = ['1-10', '11-50', '51-200', '200+'].map(size => ({ value: size, label: size }))

const fieldShape = shape({ label: string.isRequired, placeholder: string.isRequired })

function AccountForm({ form }) {
  const {
    handleFocus, handleSubmit, isCaptchaRequested, isSubmitting, error,
  } = useLeadForm({ form: 'business_account', captchaId: CAPTCHA_ID })

  return (
    <form className="business-account-form" onFocus={handleFocus} onSubmit={handleSubmit}>
      <h2 className="discover-heading cgt-heading-300">{form.title}</h2>
      <div className="business-account-form__fields">
        <InputField
          id="business-account-name"
          name="name"
          label={form.name.label}
          placeholder={form.name.placeholder}
          autoComplete="name"
          required
          className="business-account-form__field"
        />
        <InputField
          id="business-account-email"
          name="email"
          type="email"
          label={form.email.label}
          placeholder={form.email.placeholder}
          autoComplete="email"
          required
          className="business-account-form__field"
        />
        <InputField
          id="business-account-company"
          name="company"
          label={form.company.label}
          placeholder={form.company.placeholder}
          autoComplete="organization"
          required
          className="business-account-form__field business-account-form__field--half"
        />
        <SelectField
          id="business-account-company-size"
          name="company_size"
          label={form.companySize.label}
          placeholder={form.companySize.placeholder}
          options={COMPANY_SIZE_OPTIONS}
          required
          className="business-account-form__field business-account-form__field--half"
        />
      </div>
      <FormSubmit
        captchaId={CAPTCHA_ID}
        label={form.submit}
        errors={form.errors}
        isCaptchaRequested={isCaptchaRequested}
        isSubmitting={isSubmitting}
        error={error}
        className="business-account-form__submit"
      />
    </form>
  )
}

AccountForm.propTypes = {
  form: shape({
    title: string.isRequired,
    name: fieldShape.isRequired,
    email: fieldShape.isRequired,
    company: fieldShape.isRequired,
    companySize: fieldShape.isRequired,
    submit: string.isRequired,
    errors: shape({ captcha: string.isRequired, generic: string.isRequired }).isRequired,
  }).isRequired,
}

export default AccountForm
